import {Graph, alg} from '@dagrejs/graphlib';
import {fa} from '@one-click-lca/3d-buildings-shared/features';

import {TSelectedParcel} from './selectedParcelsTypes';

export function removeInvalidParcels(
  oldParcels: TSelectedParcel[],
  clickedParcel: TSelectedParcel,
): TSelectedParcel[] {
  const parcels = toggleParcel(oldParcels, clickedParcel);
  const focusedParcel = !oldParcels.find(
    p => p.properties.id === clickedParcel.properties.id,
  )
    ? clickedParcel
    : null;
  const graph = buildGraph(parcels);
  const islands = alg.components(graph);
  const filteredParcelIds = removeIslands(islands, focusedParcel);
  return parcels.filter(({properties}) =>
    filteredParcelIds.includes(properties.id),
  );
}

function toggleParcel(
  oldParcels: TSelectedParcel[],
  clickedParcel: TSelectedParcel,
): TSelectedParcel[] {
  return oldParcels.find(p => p.properties.id === clickedParcel.properties.id)
    ? oldParcels.filter(p => p.properties.id !== clickedParcel.properties.id)
    : [...oldParcels, clickedParcel];
}

function buildGraph(parcels: TSelectedParcel[]): Graph {
  const graph = new Graph();
  parcels.forEach(parcel => {
    const nodeId = parcel.properties.id;
    graph.setNode(nodeId);
    const edges = getEdges(parcels, parcel);
    edges.forEach(edge => {
      graph.setEdge(nodeId, edge);
    });
  });
  return graph;
}

function getEdges(
  parcels: TSelectedParcel[],
  nodeParcel: TSelectedParcel,
): string[] {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const bufferedNode = fa.buffer(nodeParcel, 1);

  return (
    parcels
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      .filter(p => Boolean(fa.intersection(bufferedNode, p)))
      .map(({properties}) => properties.id)
  );
}

function removeIslands(
  islands: string[][],
  focusedParcel: TSelectedParcel | null,
): string[] {
  if (!islands.length) {
    return [];
  }
  if (!focusedParcel) {
    return islands.sort((i1, i2) => i2.length - i1.length)[0];
  }
  return islands.find(i => i.includes(focusedParcel.properties.id)) || [];
}
